import { FC } from "react";
import { Alert, AlertDescription, AlertTitle } from "@altimateai/lego";
import { Link } from "react-router-dom";

export const SetupRequiredAlert: FC = () => {
  return (
    <Alert variant={"destructive"}>
      <AlertTitle className={"al-text-base"}>Setup Required</AlertTitle>
      <AlertDescription className={"al-flex al-flex-col"}>
        <span>No Snowflake connections found.</span>
        <span>
          <Link to="/settings/datastores/add" className="al-text-blue-600 al-underline al-text-sm">
            Configure a Snowflake connection
          </Link>{" "}
          to enable AI teammate.
        </span>
      </AlertDescription>
    </Alert>
  );
};
